





























































































































import Vue from 'vue';
import moment from 'moment';
import { dateFormat } from '@/constants';
import { MemberAccountResponseModel } from '@/@types/member';

export default Vue.extend({
  name: 'AccountBalance',
  props: {
    account: {
      type: Object as () => MemberAccountResponseModel,
      required: true,
    },
    accountDetail: {
      type: Object as () => any,
      required: true,
    },
  },
  computed: {
    //      currentAccount () {
    //        return Object.assign({}, this.account, this.accountDetail);
    //      },
    accountStartDate(): string {
      const startDate = moment(this.account.startDate, dateFormat),
        yearStartDate = moment().startOf('year');
      return startDate.isSameOrAfter(yearStartDate)
        ? startDate.format(dateFormat)
        : yearStartDate.format(dateFormat);
    },
    totalBalance(): number {
      return this.account.availableBalance + this.account.investmentBalance;
    },
    showInvestmentBalance(): boolean {
      return this.account.investmentBalance !== null
      &&  (this.account.productType === 'HSA' || this.account.productType === 'VEBA');
    },
  },
});
